/**
 * Stable CSS class names for E2E — MP prepare return to seller list.
 */
export const MPRTS = {
    page: 'mp-prepare-return-to-seller-list-page',
    breadcrumbSection: 'mp-prepare-return-to-seller-list-page__breadcrumb-section',
    loadingSection: 'mp-prepare-return-to-seller-list-page__loading-section',

    cargoCard: 'mp-prepare-return-to-seller-list-page__cargo-card',
    cargoCardHeader: 'mp-prepare-return-to-seller-list-page__cargo-card-header',
    cargoSelectBlock: 'mp-prepare-return-to-seller-list-page__cargo-select-block',

    searchBlock: 'mp-prepare-return-to-seller-list-page__search-block',
    gridWrap: 'mp-prepare-return-to-seller-list-page__grid-wrap',

    warningsPaper: 'mp-prepare-return-to-seller-list-page__warnings',

    actionsRow: 'mp-prepare-return-to-seller-list-page__actions-row',
    selectedCountChip: 'mp-prepare-return-to-seller-list-page__selected-count-chip',
    actionsButtonsWrap: 'mp-prepare-return-to-seller-list-page__actions-buttons-wrap',
    inputButtonExportExcel: 'mp-prepare-return-to-seller-list-page-input--button-export-excel',
    inputButtonSendShipmentMail: 'mp-prepare-return-to-seller-list-page-input--button-send-shipment-mail',

    emptyStateWrap: 'mp-prepare-return-to-seller-list-page__empty-state',

    hiddenExcelBridge: 'mp-prepare-return-to-seller-list-hidden-excel-bridge',
} as const;

export const mprtsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
